"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../..");
const tokens_1 = require("../../../styles/tokens");
const Input_styles_1 = require("./Input.styles");
const allowedInputTypes = [
    "text",
    "email",
    "number",
    "password",
    "search",
    "tel",
    "url",
    "date",
];
const isInputTypeAllowed = (type) => {
    return allowedInputTypes.includes(type);
};
const setIconColour = (isDisabled, isFocused) => {
    if (isDisabled) {
        return "stone";
    }
    if (isFocused) {
        return "blue";
    }
    return "zinc";
};
/**
 * @deprecated use Ds.TextInput instead
 */
exports.Input = (0, react_1.forwardRef)((_a, ref) => {
    var { dimension = "medium", hasErrors = false, disabled = false, isSearchInput = false, outerClassName = "" } = _a, props = __rest(_a, ["dimension", "hasErrors", "disabled", "isSearchInput", "outerClassName"]);
    if (props.type && props.type !== "text" && isSearchInput) {
        console.error("You must use an input type text if you want it to be a search input");
        return null;
    }
    if (props.type && !isInputTypeAllowed(props.type)) {
        console.error(`Input type ${props.type} is not allowed for the Input component - the allowed types are one of the following: ${allowedInputTypes.join(", ")}`);
        return null;
    }
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = (e) => {
        props.onFocus && props.onFocus(e);
        setIsFocused(true);
    };
    const handleBlur = (e) => {
        props.onBlur && props.onBlur(e);
        setIsFocused(false);
    };
    // Props to be passed to styled components
    const sharedInputAndBorderProps = {
        dimension,
        hasErrors,
        disabled,
        hasIcon: isSearchInput,
    };
    return (react_1.default.createElement(Input_styles_1.StyledInputBorder, Object.assign({}, sharedInputAndBorderProps, { isFocused: isFocused, className: outerClassName }),
        isSearchInput && (react_1.default.createElement(Input_styles_1.StyledInputIcon, { dimension: dimension },
            react_1.default.createElement(__1.Icon, { name: "Search", size: tokens_1.buttonInputFieldIconSizes[dimension].withText, colour: setIconColour(disabled, isFocused) }))),
        react_1.default.createElement(Input_styles_1.StyledInput, Object.assign({}, sharedInputAndBorderProps, props, { ref: ref, onFocus: handleFocus, onBlur: handleBlur }))));
});
//# sourceMappingURL=Input.js.map